import { render, staticRenderFns } from "./snsModal.vue?vue&type=template&id=a59ff8d0&"
import script from "./snsModal.vue?vue&type=script&lang=ts&"
export * from "./snsModal.vue?vue&type=script&lang=ts&"
import style0 from "./snsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports